// @ts-nocheck
import PropTypes from "prop-types";
import React from "react";
import className from "./ApiPulldownList.module.scss";
import { useTranslation } from "react-i18next";

export const ApiPulldownList = ({ pulldown, onClickPulldown, formName }) => {
  const { t } = useTranslation();

  return (
    <div className={className.pulldownScroll} style={{ border: "none", paddingBottom: "20px" }}>
      {pulldown.map((val, i) => (
        <button
          key={i}
          className={className.apiPulldownButton}
          type="button"
          value={formName === t("ApiPulldownList.スプレッドシートのタブ名") ? val.key : val.value}
          onClick={(e) => onClickPulldown(e)}
        >
          <div className={className.pulldownDisplay}>
            <div className={className.pulldownTitle}>{val.key}</div>
            <div
              className={className.pulldownDescription}
              style={{
                display: formName === t("ApiPulldownList.スプレッドシートのタブ名") && "none",
              }}
            >
              {val.value}
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

ApiPulldownList.propTypes = {
  pulldown: PropTypes.array,
  onClickPulldown: PropTypes.func,
  formName: PropTypes.string,
};
